module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p50"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rp50"
    }
  }, [_vm._v("VIDALIA ONION SOUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line-3.jpg",
      "width": "532"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('i', [_vm._v("The mild sweetness of Vidalia onions makes this soup special, but try it with other flavorful onion varieties too.")])])]), _vm._v(" "), _c('p', {
    staticClass: "make"
  }, [_c('span', [_vm._v("8 first-course servings")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("6 cups thinly sliced Vidalia onions")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 teaspoon sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("⅓ cup all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("6 cups reduced-sodium fat-free chicken or vegetable broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1½ teaspoons dried sage leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Salt and white pepper, to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Snipped chives or sliced green onions, as garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('b', [_vm._v("1.")]), _vm._v(" Cook onions and garlic in lightly greased large saucepan, covered, over medium-low heat until softened, 8 to 10 minutes. Stir in sugar and continue cooking, uncovered, until onions are lightly browned, about 10 minutes. Stir in flour; cook 1 minute. Add broth and herbs; heat to boiling. Reduce heat and simmer, covered, 30 minutes. Discard bay leaves. Process half the soup in food processor or blender until smooth; return to saucepan and season to taste with salt and white pepper. Serve warm or chilled; sprinkle each bowl of soup with chives.")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Per Serving:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Calories: 88")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("% calories from fat: 3")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Protein (g): 2.2")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Carbohydrate (g): 16.4")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat (g): 0.3")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Saturated fat (g): 0.1")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Cholesterol (mg): 0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Sodium (mg): 13")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Exchanges:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Milk: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Vegetable: 2.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fruit: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Bread: 0.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Meat: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("VARIATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala",
    attrs: {
      "id": "p50a"
    }
  }, [_c('span', [_c('b', [_vm._v("Baked Onion Soup with Sun-Dried Tomato Pesto")]), _vm._v(" — Make soup as above, adding ¼ cup dry sherry in Step 2. Spread 8 Bruschetta (see "), _c('span', {
    attrs: {
      "href": "#/Chapter132#p850",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 637")]), _vm._v(") with ½ cup Sun-Dried Tomato Pesto (see "), _c('span', {
    attrs: {
      "href": "#/Chapter1334#p882",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 662")]), _vm._v("). Place in bottoms of 8 oven-proof soup bowls and sprinkle with 1 cup shredded reduced-fat Italian-blend cheese. Ladle soup over and bake at 425 degrees, 10 to 15 minutes, or until cheese is melted.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf8895ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter0231.vue
// module id = 228
// module chunks = 0